module.exports = __webpack_public_path__ + "static/media/elife-school-2024-10.f8061dd8.gif";